import { render } from "./ProductListContent.vue?vue&type=template&id=973e72fa"
import script from "./ProductListContent.vue?vue&type=script&lang=js"
export * from "./ProductListContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__